import React from "react";
import { Input } from "semantic-ui-react";
import { type SemanticUiInputRef } from "utilities/hookutils";

interface Props {
  value: string
  error: boolean | string
  onChange: (value: string) => void
  onBlur: () => void
  innerRef: SemanticUiInputRef
  isLoading: boolean
}

const PasswordInputBase = (props: Props) => {
  const hasErrors = !!props.error;
  return <>
    <Input
      ref={props.innerRef.refSetter}
      fluid
      type="password"
      value={props.value}
      error={hasErrors}
      onChange={(_, { value }) => { props.onChange(value); }}
      onBlur={props.onBlur}
      loading={props.isLoading}
    />
    {typeof props.error === "string" && props.error.split("\n").map(v => (
      <div key={v} className="s1_red">
        {v}
      </div>
    ))}
  </>;
};

export default PasswordInputBase;